import { PTOGroupMembership } from 'SettingsModule/models/pto';

export const PtoGroupMembershipUtils = {
  isOngoing: (membership: PTOGroupMembership) => {
    return !membership.end_date;
  }
};
